<template>
    <div>
        <card-header title="Certification Applications" icon="fa-file-certificate"/>

        <card-body>
            <card-list>

                <cert-application-tile
                    :application="a"
                    :card="card"
                    v-for="a in confApplications"
                    @click="$openCard('conf-app', {confId: props.confId, appId: a.id}, card)"
                    :active="(child && child.definition.component === 'conf-app' && a.id === parseInt(child.props.appId))"
                />

                <card-list-item class="pb-5" no-hover>
                    <template #icon><i class="fa-fw fas fa-plus"></i></template>
                    <template #content>
                        <div class="columns">
                            <div class="column is-10">
                                <div class="mb-2">
                                    <b-select expanded placeholder="App Application" v-model="applicationSelect">
                                        <option :value="a" v-for="a in applications">{{ a.title }}</option>
                                    </b-select>
                                </div>

                            </div>
                            <div class="column has-text-right">
                                <p class="control">
                                    <button class="button is-primary" :disabled="!applicationSelect" @click="addApplication"><i class="far fa-fw fa-plus"></i></button>
                                </p>
                            </div>
                        </div>
                    </template>
                </card-list-item>
            </card-list>

        </card-body>

    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../../http_client';
    import async from "async";
    import ApplicationTile from "../../../components/tiles/ApplicationTile.vue";
    import ConfTypeTile from "../../../components/tiles/ConfTypeTile.vue";
    import CertApplicationTile from "../../../components/tiles/CertApplicationTile.vue";

    export default {
        components: {CertApplicationTile, ConfTypeTile, ApplicationTile, SeparatorListItem, SubheaderListItem, CardListItem, CourseForm, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                confApplications: [],
                applications: [],
                applicationSelect: null
            };
        },
        methods: {
            load: function(force) {
                this.$emit('loading', true);

                async.series([
                    (cb) => {
                        http.get('/conferences/' + this.props.confId + '/applications', {force}).then(response => {
                            this.confApplications = response.data;
                            cb();
                        }).catch(err => {

                        });
                    },
                    (cb) => {
                        http.get('applications', {force}).then(response => {
                            this.applications = response.data;
                            cb();
                        }).catch(err => {

                        });
                    },

                ], err => {
                    this.$emit('loading', false);

                });


            },
            addApplication: function() {
                this.$emit('loading', true);
                http.post('/conferences/' + this.props.confId + '/applications', {conference_id: this.props.confId, application_id: this.applicationSelect.id}).then(response => {
                    this.reload();
                }).catch(err => {
                    this.$emit('loading', false);
                });
            },
            reload() {
                this.load(true);
            }
        },
        watch: {
            'props.courseId': function() {
                this.dirty = null;
                this.load();
            },
            'course': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this course? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.load();
        }
    };
</script>
